import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'

import {getFinancedPriceClass, getValueFormated, getVerticalClass} from './utils.js'

export const CardAdPriceFinancedPrivate = ({
  ad,
  handleScrollToC2cPanel,
  hasForceCriticalCSS,
  instalmentPrice,
  isExtended,
  isTopSpaced = false,
  showCta = false,
  vertical
}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {TRACKING_EVENT_CONTEXTS, TRACKING_EVENT_NAMES} = config.get('tracking')

  const handleOnClickCta = async () => {
    handleScrollToC2cPanel({
      context: TRACKING_EVENT_CONTEXTS.FINANCING_PRICE_INFO,
      event: TRACKING_EVENT_NAMES.FINANCING_PRI_CALCULATOR_CLICKED
    })
  }

  const {
    financingData: {entry: adEntry, minEntry: adMinEntry} = {},
    financingInfo: {entry: adDefaultEntry} = {},
    financedPrice: adFinancedPrice,
    price: adPrice
  } = ad

  const entry = adEntry || adMinEntry || adDefaultEntry

  const financedPrice = adFinancedPrice || adPrice

  const instalmentInfoAvailable = Boolean(instalmentPrice)

  const notAvailableInstalment = !instalmentInfoAvailable & isExtended
  const showFinancedPrice = instalmentInfoAvailable || Boolean(financedPrice)
  const financingInfo = instalmentInfoAvailable ? getValueFormated(instalmentPrice) : getValueFormated(financedPrice)

  const financedCuotaClass = cx(
    'mt-CardAdPrice-financedAmountCuota',
    isTopSpaced && 'mt-CardAdPrice-financedAmountCuota--topSpaced'
  )

  return instalmentInfoAvailable || hasForceCriticalCSS ? (
    <div
      className={getVerticalClass({
        className: 'mt-CardAdPrice-financed',
        isVertical: vertical && isExtended
      })}
    >
      <div className={getFinancedPriceClass(notAvailableInstalment)}>
        <span className="mt-CardAdPrice-financedLabel mt-CardAdPrice-financedLabel--small">
          {i18n.t('COMMON.FEE_MONTHLY_PERSONAL_LOAN')}
        </span>
      </div>
      <p className={financedCuotaClass}>
        {showFinancedPrice && financingInfo}
        {instalmentInfoAvailable && (
          <span className="mt-CardAdPrice-instalment">/{i18n.t('COMMON.PLURALS.MONTH', 1).toLowerCase()}*</span>
        )}
      </p>
      <div className={getFinancedPriceClass(notAvailableInstalment)}>
        <span className="mt-CardAdPrice-financedLabel mt-CardAdPrice-financedLabel--small mt-CardAdPrice-financedLabel--extraSpace">
          {entry ? i18n.t('WITH_A_CASH_PAYMENT_OF', {amount: i18n.c(entry)}) : null}
        </span>
      </div>
      {showCta && (
        <div className="mt-CardAdPrice-extendedFooter">
          <AtomButton design={atomButtonDesigns.LINK} onClick={handleOnClickCta} size={atomButtonSizes.MEDIUM}>
            {i18n.t('COMMON.CALCULATE_FEE')}
          </AtomButton>
        </div>
      )}
    </div>
  ) : (
    <></>
  )
}
CardAdPriceFinancedPrivate.propTypes = {
  ad: PropTypes.object,
  handleScrollToC2cPanel: PropTypes.func,
  hasForceCriticalCSS: PropTypes.bool,
  instalmentPrice: PropTypes.number,
  isExtended: PropTypes.bool,
  isTopSpaced: PropTypes.bool,
  showCta: PropTypes.bool,
  vertical: PropTypes.bool
}
